import React from "react";
import { PageHero, SectionHead, PrimaryBtn, Marquee } from "../editorial/Layout";

const FEATURED = {
  n: "01",
  cat: "Essays",
  date: "September 20, 2023",
  read: "7 min",
  excerpt:
    "It's easier to design for one client. What changes when interests double, triple, and pull in opposite directions? Our approach to building genuinely family-shaped spaces — from natural light to spaces that wear well over a decade.",
  author: "Tudor Cheibas",
};

const JFeatured = () => (
  <section className="ed-section">
    <style>{`
      .jf-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: end; }
      .jf-img { aspect-ratio: 4 / 3; background: url('/assets/blog-1.jpg') center/cover; border-radius: 6px; position: relative; overflow: hidden; }
      .jf-img .tag { position: absolute; top: 18px; left: 20px; font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--paper); background: rgba(0,0,0,0.4); padding: 6px 10px; border-radius: 2px; backdrop-filter: blur(6px); letter-spacing: 0.14em; text-transform: uppercase; }
      .jf-img .num { position: absolute; bottom: 16px; right: 20px; font-family: 'JetBrains Mono', monospace; font-size: 10px; color: var(--paper); letter-spacing: 0.16em; }
      .jf-r { padding-bottom: 12px; }
      .jf-meta { display: flex; gap: 22px; font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--mute); letter-spacing: 0.14em; text-transform: uppercase; margin-bottom: 28px; }
      .jf-meta .clay { color: var(--clay); }
      .jf-r h2 { font-family: 'Fraunces', serif; font-weight: 300; font-size: 64px; line-height: 1; letter-spacing: -0.03em; margin: 0 0 24px; }
      .jf-r h2 em { font-style: italic; color: var(--clay); }
      .jf-r p { font-size: 17px; line-height: 1.55; color: var(--ink-2); margin: 0 0 32px; }
      .jf-r .row { display: flex; align-items: center; gap: 18px; padding-top: 24px; border-top: 1px solid var(--line); font-size: 13px; color: var(--mute); margin-top: 24px; }
      .jf-r .row strong { color: var(--ink); font-weight: 500; }
      @media (max-width: 960px) { .jf-grid { grid-template-columns: 1fr; } .jf-r h2 { font-size: 40px; } }
    `}</style>
    <SectionHead
      num="01"
      eyebrow="In this issue"
      title='Featured · <em>Nº 06 / 2026</em>'
      right="A monthly journal on materials, process, and the unfashionable parts of renovation. No SEO, no listicles, no promotions."
    />
    <div className="jf-grid">
      <div className="jf-img">
        <span className="tag">{FEATURED.cat} · Featured</span>
        <span className="num">{FEATURED.n} / 47</span>
      </div>
      <div className="jf-r">
        <div className="jf-meta">
          <span className="clay">— Featured essay</span>
          <span>{FEATURED.date}</span>
          <span>{FEATURED.read} read</span>
        </div>
        <h2>Designing an interior for the <em>whole family</em>.</h2>
        <p>{FEATURED.excerpt}</p>
        <PrimaryBtn>Read the essay</PrimaryBtn>
        <div className="row">
          <span>Written by <strong>{FEATURED.author}</strong></span>
          <span>·</span>
          <span>Founder &amp; project lead</span>
        </div>
      </div>
    </div>
  </section>
);

function JournalPage() {
  return (
    <main className="page-enter">
      <PageHero
        eyebrow="Journal · 05 of 06"
        title={<>Notes on the work, <em>monthly</em><span style={{ color: "var(--clay)" }}>.</span></>}
        lede="An honest journal on materials, process, and the parts of renovation nobody else writes about. Six years of receipts, one essay a month."
        meta={[
          <><strong>47</strong> Essays since 2020</>,
          <><strong>5</strong> Topics</>,
          <><strong>1×</strong> Monthly</>,
        ]}
      />
      <JFeatured />
      <Marquee items={["Essays", "Materials", "Process", "Projects", "Notes from site", "Reading list", "Tools we use", "How we hire"]} />
    </main>
  );
}

export default JournalPage;
